import { render, staticRenderFns } from "./DialogPreviewShortQuestion.vue?vue&type=template&id=76398a84&scoped=true&"
import script from "./DialogPreviewShortQuestion.vue?vue&type=script&lang=js&"
export * from "./DialogPreviewShortQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DialogPreviewShortQuestion.vue?vue&type=style&index=0&id=76398a84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76398a84",
  null
  
)

export default component.exports